import * as XLSX from "xlsx";
import { IconDownload } from "@tabler/icons-react";

const ExcelDownloader = ({ fileName }) => {
  const handleDownload = () => {
    const worksheetData = [
      [
        "Grupo",
        "TipoVale",
        "Fecha",
        "TipoMovil",
        "NMovil",
        "CentroCosto",
        "ValeFisico",
        "TotalServicio",
        "Pasajero",
        "Rut",
        "Origen",
        "Destino",
        "HoraInicio",
        "HoraTermino",
        "KMRecorrido",
        "MinRecorrido",
        "CantTAG",
        "TotalPeajes",
        "TotalEstacionamiento",
      ],
      ["1", "VALE ORIGINAL", "2025-03-03", "AUTO", "529", "7366", "212971", "23250", "NOMBRE PASAJERO", "182490911", "DIRECCION 123 COMUNA", "DIRECCION 123 COMUNA", "10:00", "10:35", "21", "0", "4", "0", "0"],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Formato");

    XLSX.writeFile(workbook, `${fileName || "Formato"}.xlsx`);
  };

  return (
    <button className="btn btn-sm rounded btn-warning" onClick={handleDownload}>
      <IconDownload className="icon icon-tabler-outline icon-tabler-download " />
      Formato
    </button>
  );
};

export default ExcelDownloader;
